import AuthService from 'common/auth/AuthService.js';
import ValidationError from 'common/libs/ValidationError.js';
import keycloakService from 'keycloak/KeycloakService.js';

import { CHANGE_USERINFO, LOAD_USER_INFO, LOGIN, LOGOUT } from './Types.js';

export function login({ username, password, rememberMe }) {
  return ({ post, dispatch }) => {
    const getPromise = async () => {
      try {
        const { id_token } = await post('/authenticate', {
          username,
          password,
          rememberMe
        });

        return AuthService.saveAuthentication(id_token, rememberMe);
      } catch (error) {
        if (error.status === 401) {
          throw new ValidationError('Usuário e/ou senha inválida', {
            field: 'password'
          });
        }
        throw error;
      }
    };

    return {
      type: LOGIN,
      payload: getPromise().then(() => dispatch(loadUserInfo())),
      meta: {
        credentials: {
          username,
          rememberMe
        }
      }
    };
  };
}

export function logout() {
  return ({ getState }) => {
    AuthService.clearAuthentication();
    AuthService.clearUserInfo();
    AuthService.clearRefreshToken();

    return {
      type: LOGOUT,
      payload:
        getState().config.integradoUnico || getState().config.isStandalone
          ? new Promise(resolve => resolve())
          : keycloakService.logout()
    };
  };
}

const mergeUserInfo = userInfo => {
  const mergedUserInfo = {
    ...userInfo,
    entidade: userInfo.entidade || userInfo.entidadePadrao,
    exercicio: userInfo.exercicio || userInfo.exercicioPadrao
  };

  AuthService.saveUserInfo(mergedUserInfo);

  return mergedUserInfo;
};

export function updateUserInfo(userInfo) {
  const getPromise = async () => mergeUserInfo(userInfo);

  return {
    type: CHANGE_USERINFO,
    payload: getPromise()
  };
}

export function loadUserInfo() {
  return ({ fetch }) => {
    return {
      type: LOAD_USER_INFO,
      payload: fetch('/userinfo').then(mergeUserInfo)
    };
  };
}

export function reviveUserInfo() {
  return ({ fetch }) => {
    const getPromise = async () => {
      const userInfo = await fetch('/userinfo');
      const currentUserInfo = AuthService.getUserInfo();
      const revivedUserInfo = {
        ...userInfo,
        ...currentUserInfo
      };

      return mergeUserInfo(revivedUserInfo);
    };

    return {
      type: LOAD_USER_INFO,
      payload: getPromise()
    };
  };
}
